<template>
          <VueCtkDateTimePicker
            v-model="content"
            right
            format="HH:mm"
            :only-time="true"
            :no-value-to-custom-elem="true"
            color="primary"
            class="timePickerOveride"
            :no-button-now="true"
          >

        <v-text-field  
            ref="tf"
            color="primary"
            dense
            class="text-caption"
            :value="content"
            prepend-inner-icon="access_time"
            readonly
            :label="label"
            :disabled="disabled"
            :error-messages="errorMessages"></v-text-field>
            
          </VueCtkDateTimePicker>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  components: {
    VueCtkDateTimePicker
  },
  props: {
    value: {
      type: Number | String,
      required: false
    },
    errorMessages: {
      type: Array,
      requred: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    label: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      content: '',
      enabled: false
    }
  },
  mounted() {
    this.syncContentWithValue()
  },
  methods: {
    syncContentWithValue() {
      if (this.value === '' || this.value == undefined) {
        this.content = ''
        return
      }
      let timeParts = this.value.toString().split('.')
      let leftPart = timeParts[0] < 10 ? '0' + timeParts[0] : timeParts[0]
      let rightPart = '00'
      if (timeParts[1]) {
        rightPart = timeParts[1] < 10 ? '0' + timeParts[1] : timeParts[1]
      }
      this.content = `${leftPart}:${rightPart}`
    }
  },
  watch: {
    content: {
      handler() {
        if (this.content !== '') {
          let timeParts = this.content.split(':')
          let leftPart = Number(timeParts[0])
          let rightPart = Number(timeParts[1])
          let numberToEmit = leftPart
          if (rightPart) {
            numberToEmit += '.' + rightPart
          } else {
            numberToEmit += '.' + 0
          }
          numberToEmit = parseFloat(numberToEmit).toFixed(2)
          this.$emit('input', numberToEmit)
        }
      }
    },
    value: {
      handler() {
        this.syncContentWithValue()
      }
    }
  }
}
</script>

<style>
.checkboxOveride {
  margin-top: 0px;
  padding-top: 0px;
}
.checkboxOveride >>> div > div > div {
  margin-right: 0px;
}
.textFieldOveride >>> div:last-child {
  padding-right: 0px;
  padding-left: 0px;
}
/* Velicina brojeva sata  */
.timePickerOveride :first-child >>> div > div div {
  font-size: 36px;
  height: 18px;
}
/* Velicina kontejnera sata  */
.timePickerOveride >>> div:nth-child(1) {
  padding-top: 0px;
  padding-bottom: 0px;
}
/* Visina titlea */
/* .timePickerOveride >>>div:nth-child(1) >div {
height: 50px;
} */
/* Dve tacke na satu */
.timePickerOveride >>> div > div:nth-child(1) > div > span {
  font-size: 26px;
}
/* Velicina AM-PM */
.timePickerOveride :first-child >>> div > div:nth-child(2) > div {
  font-size: 12px;
}
/* Margina AM */
.timePickerOveride :first-child >>> div > div:nth-child(2) {
  margin-bottom: 0px;
}
.textFieldInput >>> div :last-child > div {
  font-size: 6px;
}
</style>
